import React from "react";
import Image from "next/image";
import {Container} from "@/shared/components/shared";

export const MobileApp: React.FC = () => {
    return (
        <section className="bg-gradient-to-b from-[#202025] to-[#5A5A66] py-16 relative overflow-hidden">
            <div className="absolute right-0 top-0 bottom-0 opacity-20">
                <div className="w-full h-full"></div>
            </div>

            <Container className="px-5 sm:px-0 relative z-10">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-8 px-5 xl:px-0">
                    <div className="flex-1 text-white lg:max-w-2xl">
                        <div className="mb-8 grid grid-cols-[1fr_auto] items-baseline gap-x-4 w-full">
                            <div className="flex flex-col">
                                <div
                                    className="text-[52px] lg:text-[100px] font-bold uppercase leading-tight text-left w-full">
                                    ЭЛЕКТРОННАЯ
                                </div>
                                <div className={'flex justify-between items-center align-center'}>
                                    <div className="text-[52px] lg:text-[100px] font-bold uppercase leading-tight text-left w-fit">
                                        Лучше
                                    </div>
                                    <div className="text-[18px] lg:text-[36px] leading-tight font-light text-right leading-tight">
                                        <div>сервисная книжка</div>
                                        <div>вашего автомобиля</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="lg:hidden">
                            <div className="mt-6">
                                <Image
                                    src="/images/mobile-app/main.png"
                                    alt="Электронная версия лучше"
                                    width={1000}
                                    height={1500}
                                    className="w-full h-auto"
                                    priority
                                />
                            </div>

                            <div className="mt-6 bg-custom-orange py-4 text-center">
                                <p className="text-white text-[16px] font-bold uppercase">
                                    ЦЕНЫ В ПРИЛОЖЕНИИ НИЖЕ
                                </p>
                            </div>

                            <p className="text-white text-[14px] mt-4 text-center uppercase tracking-wide">
                                ВЫГОДНОЕ ОБСЛУЖИВАНИЕ
                            </p>

                            <div className="mt-6">
                                <p className="text-white text-[24px] font-normal uppercase text-center">
                                    СКАЧАТЬ
                                </p>
                            </div>

                            <div className="mt-4 flex flex-row items-center justify-center gap-2">
                                <a href="https://play.google.com/store/apps/details?id=ru.ortus.assistant">
                                    <Image
                                        src="/images/mobile-app/google_btn.svg"
                                        alt="Google Play"
                                        width={200}
                                        height={60}
                                        className="w-[140px] h-[42px]"
                                    />
                                </a>
                                <a href="https://apps.apple.com/ru/app/ortus-%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BD%D0%B8%D0%B6%D0%BA%D0%B0/id1189488678">
                                    <Image
                                        src="/images/mobile-app/apple_btn.svg"
                                        alt="App Store"
                                        width={200}
                                        height={60}
                                        className="w-[140px] h-[42px]"
                                    />
                                </a>
                            </div>
                        </div>

                        {/* Десктоп версия */}
                        <div className="hidden lg:flex flex-col gap-4 mb-6">
                            <p className="text-white text-[24px] font-light uppercase">СКАЧАТЬ</p>
                            <div className="flex flex-row items-start gap-4">
                                <div className="flex flex-col items-center gap-2">
                                    <a href="https://play.google.com/store/apps/details?id=ru.ortus.assistant">
                                        <Image
                                            src="/images/mobile-app/google_btn.svg"
                                            alt="Google Play"
                                            width={200}
                                            height={60}
                                            className="w-[140px] h-[42px] lg:w-[200px] lg:h-[60px] hover:opacity-80 transition-opacity"
                                        />
                                    </a>
                                    <div
                                        className="border-8 lg:border-16 border-white w-[140px] h-[140px] lg:w-[200px] lg:h-[200px] rounded-lg overflow-hidden">
                                        <Image
                                            src="/images/mobile-app/qr-google.png"
                                            alt="QR код Google Play"
                                            width={184}
                                            height={184}
                                            className="w-[124px] h-[124px] lg:w-[168px] lg:h-[168px]"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-2">
                                    <a href="https://apps.apple.com/ru/app/ortus-%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BD%D0%B8%D0%B6%D0%BA%D0%B0/id1189488678">
                                        <Image
                                            src="/images/mobile-app/apple_btn.svg"
                                            alt="App Store"
                                            width={200}
                                            height={60}
                                            className="w-[140px] h-[42px] lg:w-[200px] lg:h-[60px] hover:opacity-80 transition-opacity"
                                        />
                                    </a>
                                    <div
                                        className="border-8 lg:border-16 border-white w-[140px] h-[140px] lg:w-[200px] lg:h-[200px] rounded-lg overflow-hidden">
                                        <Image
                                            src="/images/mobile-app/qr-apple.png"
                                            alt="QR код App Store"
                                            width={184}
                                            height={184}
                                            className="w-[124px] h-[124px] lg:w-[168px] lg:h-[168px]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Правая часть - изображение телефона (только десктоп) */}
                    <div className="hidden lg:flex flex-1 justify-end w-full overflow-visible">
                        <div className="relative">
                            <Image
                                src="/images/mobile-app/main.png"
                                alt="Электронная версия лучше"
                                width={1000}
                                height={1500}
                                className="w-full h-auto overflow-visible"
                                priority
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};